export async function parseImages(
  images: HTMLImageElement[] | File[]
): Promise<HTMLImageElement[]> {
  if (images.length <= 0) {
    throw new Error("No Image sent.");
  }

  if (images[0] instanceof File) {
    const promises: any = [];
    for (const iterator of images) {
      promises.push(loadImage(iterator as File));
    }

    return Promise.all(promises);
  }

  return images as HTMLImageElement[];
}

async function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((rs, rj) => {
    const fr = new FileReader();
    const img = document.createElement("img");

    fr.onload = () => {
      img.src = fr.result as string;
      rs(img);
    };

    fr.onerror = (d) => {
      rj(d);
    };

    fr.readAsDataURL(file);
  });
}
